export function capitalizeFirstLetter(str){
    return str.slice(0, 1).toUpperCase() + str.slice(1)
}